// extracted by mini-css-extract-plugin
export default {"clubLogoWrapper":"club-logo_clubLogoWrapper__JSSOD","disabled":"club-logo_disabled__3JRo2"};